import React from 'react';
import { AssetUrls } from 'config/assets';
import './PriceRangeFilter.css';

/**
 * Min/Max price (point-value) range inputs. Shared between the Send page toolbar
 * and the Trade Alerts filter row so both surfaces use the same convention.
 *
 * Values are non-negative integers; commas are stripped on input and any value
 * <= 0 (or non-numeric) is treated as "unset" (`undefined`).
 *
 * NOTE: the markup keeps the `send-price-*` class names so the Send page styling
 * is identical to before this was extracted out of `sendToolbarControls.tsx`.
 */
export function PriceRangeFilter({
  priceMin,
  priceMax,
  onPriceMinChange,
  onPriceMaxChange,
  minLabel = 'Price (min.)',
  maxLabel = 'Price (max.)',
}: {
  priceMin?: number;
  priceMax?: number;
  onPriceMinChange?: (value: number | undefined) => void;
  onPriceMaxChange?: (value: number | undefined) => void;
  /** Field labels — override to repurpose the control (e.g. "Trader balance (min.)"). */
  minLabel?: string;
  maxLabel?: string;
}) {
  return (
    <div className="send-price-filter">
      <div className="send-price-field">
        <label>{minLabel}</label>
        <div className="send-price-input-wrapper">
          <img
            src={`${AssetUrls.base}/assets/icons/profile/coin.svg`}
            className="send-price-coin-icon"
            alt=""
          />
          <input
            type="text"
            className="send-price-input"
            placeholder="0"
            value={priceMin ?? ''}
            onChange={(e) => {
              const val = e.target.value.replace(/,/g, '');
              const num = parseInt(val, 10);
              onPriceMinChange?.(isNaN(num) || num <= 0 ? undefined : num);
            }}
          />
        </div>
      </div>
      <div className="send-price-field">
        <label>{maxLabel}</label>
        <div className="send-price-input-wrapper">
          <img
            src={`${AssetUrls.base}/assets/icons/profile/coin.svg`}
            className="send-price-coin-icon"
            alt=""
          />
          <input
            type="text"
            className="send-price-input"
            placeholder="999,999"
            value={priceMax ?? ''}
            onChange={(e) => {
              const val = e.target.value.replace(/,/g, '');
              const num = parseInt(val, 10);
              onPriceMaxChange?.(isNaN(num) || num <= 0 ? undefined : num);
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default PriceRangeFilter;
